const url = "https://api.cloudinary.com/v1_1/dorip8bfj/image/upload"; // ✅ Corrected Cloud Name

const uploadImage = async (image) => {
  const formData = new FormData();
  formData.append("file", image);
  formData.append("upload_preset", "mern_product"); // ✅ Ensure this upload preset exists

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    alert("Failed to upload image. Check your Cloudinary settings.");
  }
};

export default uploadImage;
